
class ThreeJSSolarSystemCtrl{

}

export default ThreeJSSolarSystemCtrl;



// WEBPACK FOOTER //
// ./app/scripts/controllers/threejsSolarSystem.js